<template>
  <div class="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4" :style="`background-image: url('${backgroundImage}');`">
    <div class="ui-bg-overlay bg-white opacity-25"></div>

    <div class="authentication-inner py-5">
      <!-- <div v-if="portalLogo" class="text-center mb-4">
        <img :src="portalLogo" alt="logo" class="public-layout-logo">
      </div> -->
      <router-view />
    </div>

    <span class="public-layout-version small text-muted">API: {{ api_version }} / Front: {{ $store.getters.appVersion }}</span>
  </div>
</template>

<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>
<style scoped>
.public-layout-version {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 0.25rem 0.5rem;
  z-index: 1030;
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 4px 0 0 0;
}
.public-layout-logo {
  max-height: 80px;
  max-width: 100%;
}
</style>

<script>
export default {
    name: 'app-layout-public',
    data () {
        return {
            api_version: localStorage.getItem('version'),
            defaultBackground: '/calm-beach.jpg'
        }
    },
    computed: {
        backgroundImage () {
            return this.$store.state.office.portal_background || this.defaultBackground
        },
        portalLogo () {
            return this.$store.state.office.portal_logo || ''
        }
    }
}
</script>
